export function createServiceProps(productName) {
  const serviceFor = window.sga.locales.cart.service_for;

  return {
    [serviceFor]: productName,
  };
}
